import { FC, useEffect } from 'react';
import styles from './styles.module.scss';
import Phone from '@components/phone';
import Typography from '@components/common/typography';
import { useTranslation } from 'react-i18next';
import { useLocales } from '@hooks/helpers/useLocales';
import { IModalComponentProps } from '@context/modal_context';
import { getDefaultPhoneCode } from '@utils/index';

const AddPhoneModal: FC<IModalComponentProps<{ phone_code: string; phone_number: string }>> = ({
    modalData,
    changeModalData
}) => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'add_phone'
    });
    const { labelLocale } = useLocales();

    useEffect(() => {
        changeModalData({ ...modalData, phone_code: getDefaultPhoneCode() });
    }, []);

    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4" weight="bold" alignment="center">
                {t('title')}
            </Typography>
            <div className={styles.content}>
                <Phone
                    label={labelLocale('enter_phone')}
                    isForm={false}
                    phone_code={modalData?.phone_code}
                    phone_number={modalData?.phone_number}
                    onPhoneChange={(value) =>
                        changeModalData({ ...modalData, phone_number: value })
                    }
                    onCodeChange={(value) => changeModalData({ ...modalData, phone_code: value })}
                    selectSize="small"
                />
            </div>
        </div>
    );
};

export default AddPhoneModal;
